import { render, staticRenderFns } from "./collectCard.vue?vue&type=template&id=6c44c8a2&scoped=true&"
import script from "./collectCard.vue?vue&type=script&lang=js&"
export * from "./collectCard.vue?vue&type=script&lang=js&"
import style0 from "./collectCard.vue?vue&type=style&index=0&id=6c44c8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c44c8a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c44c8a2')) {
      api.createRecord('6c44c8a2', component.options)
    } else {
      api.reload('6c44c8a2', component.options)
    }
    module.hot.accept("./collectCard.vue?vue&type=template&id=6c44c8a2&scoped=true&", function () {
      api.rerender('6c44c8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/collectCard.vue"
export default component.exports